import M from 'backbone.marionette'
import TListItem from './punchlistitem.html'
import T from './specialistepunchlist.html'
import { showModal } from '../../../utils/bootstrap/modal';
import { EditPunch } from '../edit';
import { minutesToTimeString } from '../../../utils/utils';
import { FormElement } from '../../../utils/bootstrap/formelement';
import Radio from 'backbone.radio';

const PunchElement = M.View.extend({
    tagName: 'a',
    attributes: function(){
        let url = '#';
        switch(this.model.get('relatedModel')){
            case 'competenceetudiant':
                url = './candidat/competence/' + this.model.get('relatedId');
                break;
            case 'evals':
                url = './evaluation/fiche/' + this.model.get('relatedId')
                break;
            default:
                break;
        }
        return {
            target: '_blank',
            href: url
        }
    },
    events: {
        'click':'onClick'
    },
    onClick: function(event){
        event.stopPropagation();
    },
    template: _.template('<%=value%>'),
    serializeData: function(){
        let out;
        switch(this.model.get('relatedModel')){
            case 'competenceetudiant':
                out = this.model.get('model').etudiant.Prenom + ' ';
                out += this.model.get('model').etudiant.NomFamille;
                out += ' compétence ';
                out += this.model.get('model').competence.CodeCompetence;
                return {value: out};
            case 'evals':
                out = this.model.get('model').title;
                return {value: out}
        }
    }
})

const ListItem = M.View.extend({
    tagName: 'tr',
    template: _.template(TListItem),
    serializeData: function(){
        return _.extend(this.model.toJSON(),{
            admin: this.getOption('mainModel').get('user').get('admin'),
            budget: this.model.get('budget_id') ? this.getOption('mainModel').get('budgets').get(this.model.get('budget_id')).toJSON() : null
        });
    },
    ui: {
        'checkbox':'input[type=checkbox]',
    },
    events: {
        'click checkbox':'onCheckboxClick',
        'click .btModifier':'onClick',
        'mouseover':'onOver',
        'mouseout':'ouOut',
        
    },
    onOver: function(){
        //this.$el.addClass('active');
    },
    onOut: function(){
        //this.$el.removeClass('active');
    },
    onClick: function(event){
        event.preventDefault();
        event.stopPropagation();
        showModal('Modifier', new EditPunch({
            model: this.model,
            mainModel: this.getOption('mainModel')
        }))
    },
    onCheckboxClick: function(event){
        event.stopPropagation();
    },
    initialize: function(){
        Radio.channel('punch').on('selectPunshByBudget', this.selectPunshByBudget, this);
        Radio.channel('punch').on('selectAll', this.selectAll, this);
        Radio.channel('punch').on('selectNone', this.selectNone, this);
    },
    onDestroy: function(){
        Radio.channel('punch').off('selectPunshByBudget', this.selectPunshByBudget, this);
        Radio.channel('punch').off('selectAll', this.selectAll, this);
        Radio.channel('punch').off('selectNone', this.selectNone, this);
    },
    regions: {
        'punchDate':'.punchDate',
        'punchTimeString':'.punchTimeString',
        'punchElement':'.punchElement',
        'punchType':'.punchType',
    },
    selectPunshByBudget: function(budget_id){
        if(this.model.get('budget_id') == budget_id){
            this.ui.checkbox.prop('checked', true);
        }else{
            this.ui.checkbox.prop('checked', false);
        }
    },
    selectAll: function(){
        this.ui.checkbox.prop('checked', true);
    },
    selectNone: function(){
        this.ui.checkbox.prop('checked', false);
    },
    onRender: function(){
        /*
        this.showChildView('punchDate', new FormElement({
            inpuOnly: true,
            type: 'date',
            model: this.model,
            attribute: 'punchDate',
        }));
        this.showChildView('punchTimeString', new FormElement({
            inpuOnly: true,
            type: 'time',
            model: this.model,
            attribute: 'punchTimeString',
        }));
        */
        this.showChildView('punchElement', new PunchElement({model: this.model}))
        /*
        this.showChildView('punchType', new FormElement({
            inpuOnly: true,
            type: 'select',
            model: this.model,
            attribute: 'punchType',
            collection: this.getOption('mainModel').get('punchTypes')
        }));
        */
    }
});

const AdminListItem = ListItem.extend({

})

const ListItemEval = ListItem.extend({

})

const LaListe = M.CollectionView.extend({
    tagName: 'tbody',
    childView: ListItem
});

export const SpecialistePunchList = M.View.extend({
    template: _.template(T),
    regions: {
        'liste':{
            el: 'tbody.punches',
            replaceElement: true
        },
        'taux':'.taux'
    },
    events: {
        'change [name="punchids[]"]': 'onSelectedPunchChanged',
        'click .btTous':'onTousClick',
        'click .btAucun':'onAucunClick',
    },
    onSelectedPunchChanged: function(){
        const ids = []
        this.$el.find('[name="punchids[]"]:checked').map(function(p, el){
            ids.push(el.value);
        })
    },
    onTousClick: function(event){
        event.preventDefault();
        event.stopPropagation();
        Radio.channel('punch').trigger('selectAll', this.model.get('id'));
    },
    onAucunClick: function(event){
        event.preventDefault();
        event.stopPropagation();
        Radio.channel('punch').trigger('selectNone', this.model.get('id'));
    },
    serializeData: function(){
        const total = this.collection.reduce(function(acc, curr){
            return acc + curr.get('punchTimeInMinutes');
        },0);
        return _.extend(this.model.toJSON(), {
            total: total,
            totalString: minutesToTimeString(total),
            admin: this.getOption('mainModel').get('user').get('admin')
        })
    },
    onRender: function(){
        this.showChildView('liste', new LaListe({
            model: this.getOption('mainModel'),
            collection: this.getOption('collection'),
            childViewOptions: this.getOption('childViewOptions')
        }));
        if(this.getOption('mainModel').get('user').get('admin') && !this.getOption('mainModel').get('punchreport').get('traitee')){
            this.showChildView('taux', new FormElement({
                inpuOnly: true,
                type: 'number',
                inputAttributes: {
                    'min':'0.00',
                    'step':'0.01'
                },
                model: this.model,
                attribute: 'taux',
            }));
        }
    },
});